import { Order_detail } from '../../../../Component/Interface/Order';
import { RenderOrderCells } from '../../../../Component/style/orderTable_style2';
import { automaticRefundAmount } from './RefundAmountFields';

export function productNetAmount(detail: Order_detail, cancelQuantity = 0) {
  if (!cancelQuantity) return detail.net_product_amount ?? Math.max(0, detail.order_price - Number(detail.cancel_price || 0) - Number(detail.coupon_discount_amount || 0));
  const remaining = Math.max(0, detail.order_cnt - Number(detail.cancel_cnt || 0));
  return Math.max(0, automaticRefundAmount(detail, remaining) - automaticRefundAmount(detail, Math.min(cancelQuantity, remaining)));
}

export default function OrderProductPaymentCells({ details, cancelQtyMap, style }: {
  details: Order_detail[]; cancelQtyMap?: Record<number, number>; style?: React.CSSProperties;
}) {
  const amount = (detail: Order_detail) => productNetAmount(detail, cancelQtyMap ? cancelQtyMap[detail.detail_seq] ?? detail.order_cnt : 0);
  return <>
    <RenderOrderCells detailData={details} searchkey="할인 금액" cellStyle={style} renderCell={seq => {
      const detail = details.find(item => item.detail_seq === seq)!;
      const quantity = Math.max(0, detail.order_cnt - Number(detail.cancel_cnt || 0) - (cancelQtyMap ? cancelQtyMap[seq] ?? detail.order_cnt : 0));
      const discount = cancelQtyMap ? Math.max(0, quantity * detail.product_price - amount(detail)) : Number(detail.coupon_discount_amount || 0);
      return discount.toLocaleString('ko-KR');
    }} />
    <RenderOrderCells detailData={details} searchkey="할인 후 금액" cellStyle={style} renderCell={seq => amount(details.find(item => item.detail_seq === seq)!).toLocaleString('ko-KR')} />
  </>;
}
